var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _vm.is_null(_vm.from)
            ? _c(
                "el-breadcrumb",
                { attrs: { separator: "" } },
                [
                  !_vm.title
                    ? _c("el-breadcrumb-item", [
                        _c("div", { staticClass: "div1" }, [
                          _vm._v("订单管理"),
                        ]),
                      ])
                    : _vm._e(),
                  !_vm.title
                    ? _c(
                        "el-breadcrumb-item",
                        { attrs: { to: { name: "orderList" } } },
                        [
                          _c("div", { staticClass: "div3" }, [
                            _vm._v("我的订单"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  !_vm.title
                    ? _c("el-breadcrumb-item", [
                        _c("div", { staticClass: "div2" }, [
                          _vm._v("订单详情"),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.title
                    ? _c("el-breadcrumb-item", [
                        _c(
                          "div",
                          {
                            staticClass: "div1",
                            on: {
                              click: function ($event) {
                                return _vm.$router.back(-1)
                              },
                            },
                          },
                          [_vm._v(" 客户管理 ")]
                        ),
                      ])
                    : _vm._e(),
                  !_vm.is_null(_vm.content.orderUser) && _vm.title
                    ? _c(
                        "el-breadcrumb-item",
                        {
                          attrs: {
                            to: {
                              name: "customerListOrder",
                              query: { id: _vm.content.orderUser.userId },
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "div3" }, [
                            _vm._v("客户订单"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.title
                    ? _c("el-breadcrumb-item", [
                        _c("div", { staticClass: "div2" }, [
                          _vm._v("订单详情"),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _c(
                "el-breadcrumb",
                { attrs: { separator: "" } },
                [
                  !_vm.title
                    ? _c("el-breadcrumb-item", [
                        _c("div", { staticClass: "div1" }, [
                          _vm._v("客户管理"),
                        ]),
                      ])
                    : _vm._e(),
                  !_vm.title
                    ? _c(
                        "el-breadcrumb-item",
                        { attrs: { to: { name: "customersList" } } },
                        [
                          _c("div", { staticClass: "div3" }, [
                            _vm._v("客户列表"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  !_vm.title
                    ? _c(
                        "el-breadcrumb-item",
                        {
                          attrs: {
                            to: {
                              name: "customerInformation",
                              query: { unavName: 1, uid: _vm.uid, id: _vm.id },
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "div3" }, [
                            _vm._v("消费记录"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  !_vm.title
                    ? _c("el-breadcrumb-item", [
                        _c("div", { staticClass: "div2" }, [
                          _vm._v("消费详情"),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.title
                    ? _c("el-breadcrumb-item", [
                        _c("div", {
                          staticClass: "div1",
                          on: {
                            click: function ($event) {
                              return _vm.$router.back(-1)
                            },
                          },
                        }),
                      ])
                    : _vm._e(),
                  !_vm.is_null(_vm.content.orderUser) && _vm.title
                    ? _c(
                        "el-breadcrumb-item",
                        {
                          attrs: {
                            to: {
                              name: "customerInformation",
                              query: { id: _vm.content.orderUser.userId },
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "div3" }, [
                            _vm._v("消费记录"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.title
                    ? _c("el-breadcrumb-item", [
                        _c("div", { staticClass: "div2" }, [
                          _vm._v("消费详情"),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
        ],
        1
      ),
      !_vm.is_null(_vm.from)
        ? _c("div", { staticClass: "money" }, [
            _c("div", { staticClass: "headerNav" }, [
              _c("span", [_vm._v("收货信息")]),
              _c("div", { staticClass: "right" }, [
                _c(
                  "p",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.examineLogistics()
                      },
                    },
                  },
                  [
                    _c(
                      "el-button",
                      { attrs: { type: "primary", size: "mini" } },
                      [_vm._v("查看物流")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  "margin-left": "10px",
                  "font-size": "15px",
                  "margin-top": "14px",
                },
              },
              [
                !_vm.is_null(_vm.logistics) &&
                !_vm.is_null(_vm.logistics.orderStatus)
                  ? _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.logistics.orderStatus == 1
                              ? "待签收"
                              : "暂无" || _vm.logistics.orderStatus == 2
                              ? "已签收"
                              : "暂无"
                          ) +
                          " "
                      ),
                    ])
                  : _c("span", [_vm._v("暂无物流信息")]),
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  "margin-left": "10px",
                  "font-size": "15px",
                  "margin-top": "14px",
                },
              },
              [
                !_vm.is_null(_vm.logistics) &&
                !_vm.is_null(_vm.logistics.logisticsCompany)
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.logistics.logisticsCompany
                            ? _vm.logistics.logisticsCompany
                            : "暂无"
                        ) +
                          " : " +
                          _vm._s(
                            _vm.logistics.parcelNumber
                              ? _vm.logistics.parcelNumber
                              : "暂无"
                          )
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ])
        : _vm._e(),
      !_vm.is_null(_vm.content.orderUser)
        ? _c("div", { staticClass: "money" }, [
            _c("div", { staticClass: "headerNav" }, [
              _c("span", [_vm._v("金额状态")]),
              _vm.is_null(_vm.from)
                ? _c("div", { staticClass: "right" }, [
                    _vm.parArray.indexOf("wxQrCode") != -1 &&
                    Number(_vm.content.orderUser.receivedMoney) <
                      Number(_vm.content.orderUser.total)
                      ? _c(
                          "p",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.qrtypeEvent(1)
                              },
                            },
                          },
                          [
                            _c(
                              "el-button",
                              { attrs: { type: "primary", size: "mini" } },
                              [_vm._v("生成支付二维码")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.content.orderUser.logisticsOrder &&
                    _vm.parArray.indexOf("logisticsQrCode") != -1
                      ? _c(
                          "p",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.qrtypeEvent(2)
                              },
                            },
                          },
                          [
                            _c(
                              "el-button",
                              { attrs: { type: "primary", size: "mini" } },
                              [_vm._v("生成物流二维码")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.parArray.indexOf("transactionHistory") != -1
                      ? _c(
                          "p",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.transactionrecord()
                              },
                            },
                          },
                          [
                            _c(
                              "el-button",
                              { attrs: { type: "primary", size: "mini" } },
                              [_vm._v("交易记录")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "contentTotal" }, [
              _c("p", [
                _c("span", [
                  _vm._v(
                    "已收金额：￥" + _vm._s(_vm.content.orderUser.receivedMoney)
                  ),
                ]),
              ]),
              _c("p", [
                _c("span", [
                  _vm._v(
                    "待收金额：￥" +
                      _vm._s(_vm.content.orderUser.awaitIncomeMoney)
                  ),
                ]),
              ]),
              _c("p", [
                _c("span", [
                  _vm._v("总金额：￥" + _vm._s(_vm.content.orderUser.total)),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _c("div", { staticClass: "state" }, [
        !_vm.is_null(_vm.content.orderUser)
          ? _c("p", { staticClass: "header" }, [
              _vm._v(
                " 订单状态：" + _vm._s(_vm.content.orderUser.orderType) + " "
              ),
            ])
          : _vm._e(),
        _c("ul", [
          _c("li", [
            _vm.content.orderUser && _vm.content.orderUser.userIntentionName
              ? _c("p", [
                  _vm._v(
                    " 客户类型：" +
                      _vm._s(_vm.content.orderUser.userIntentionName) +
                      " "
                  ),
                ])
              : _vm._e(),
            _vm.content.orderUser && _vm.content.orderUser.customerUser
              ? _c("p", [
                  _vm._v(
                    " 入线方式：" +
                      _vm._s(_vm.content.orderUser.customerUser.userDitchName) +
                      " "
                  ),
                ])
              : _vm._e(),
            _vm.content.orderUser && _vm.content.orderUser.customerUser
              ? _c("p", [
                  _vm._v(
                    " 入线时间：" +
                      _vm._s(_vm.content.orderUser.customerUser.ditchTime) +
                      " "
                  ),
                ])
              : _vm._e(),
            !_vm.is_null(_vm.content.orderUser)
              ? _c("p", [
                  _vm._v(
                    " 下单时间：" +
                      _vm._s(_vm.content.orderUser.createdTime) +
                      " "
                  ),
                ])
              : _vm._e(),
            !_vm.is_null(_vm.content.orderUser)
              ? _c("p", [
                  _vm._v(
                    " 订单编号：" +
                      _vm._s(_vm.content.orderUser.orderIdStr) +
                      " "
                  ),
                ])
              : _vm._e(),
            _vm.is_null(_vm.content.orderUser)
              ? _c("p", [_vm._v("发货时间：空")])
              : _vm._e(),
            !_vm.is_null(_vm.content.orderUser) &&
            !_vm.is_null(_vm.content.orderUser.logisticsOrder)
              ? _c("p", [
                  _vm._v(
                    " 发货时间：" +
                      _vm._s(
                        _vm.content.orderUser.logisticsOrder.deliveryTime
                      ) +
                      " "
                  ),
                ])
              : _vm._e(),
            !_vm.is_null(_vm.content.orderUser) &&
            !_vm.is_null(_vm.content.orderUser.logisticsOrder)
              ? _c("p", [
                  _vm._v(
                    " 签收时间：" +
                      _vm._s(_vm.content.orderUser.logisticsOrder.signTime) +
                      " "
                  ),
                ])
              : _vm._e(),
            _vm.is_null(_vm.content.orderUser)
              ? _c("p", [_vm._v("签收时间：空")])
              : _vm._e(),
          ]),
          _c("li", [
            !_vm.is_null(_vm.content.orderUser) &&
            !_vm.is_null(_vm.content.orderUser.logisticsOrder)
              ? _c("p", [
                  _vm._v(
                    " 物流公司：" +
                      _vm._s(
                        _vm.content.orderUser.logisticsOrder.logisticsCompany
                      ) +
                      " "
                  ),
                ])
              : _vm._e(),
            !_vm.is_null(_vm.content.orderUser) &&
            !_vm.is_null(_vm.content.orderUser.logisticsOrder)
              ? _c("p", [
                  _vm._v(
                    " 物流订单号：" +
                      _vm._s(
                        _vm.content.orderUser.logisticsOrder.parcelNumber
                      ) +
                      " "
                  ),
                ])
              : _vm._e(),
          ]),
          _c(
            "li",
            [
              !_vm.is_null(_vm.content.orderUser) &&
              !_vm.is_null(_vm.content.orderUser.logisticsOrder) &&
              _vm.content.orderUser.logisticsOrder.orderStatus == "1" &&
              _vm.parArray.indexOf("dqskhqs") != -1
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.customerSign },
                    },
                    [_vm._v("客户签收")]
                  )
                : _vm._e(),
              !_vm.is_null(_vm.content.orderUser) &&
              !_vm.is_null(_vm.content.orderUser.logisticsOrder) &&
              _vm.content.orderUser.logisticsOrder.orderStatus == "2" &&
              _vm.parArray.indexOf("yqsxgwwqs") != -1
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.cancelSign },
                    },
                    [_vm._v("修改未签收")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "address" }, [
        _c("p", { staticClass: "header" }, [_vm._v("收货人信息")]),
        _c("ul", [
          _c("li", [
            !_vm.is_null(_vm.content.orderUser)
              ? _c("p", [
                  _vm._v(
                    " 收货人姓名：" +
                      _vm._s(_vm.content.orderUser.addressName) +
                      " "
                  ),
                ])
              : _vm._e(),
            !_vm.is_null(_vm.content.orderUser)
              ? _c("p", [
                  _vm._v(
                    " 联系电话：" +
                      _vm._s(_vm.content.orderUser.addressPhone) +
                      " "
                  ),
                ])
              : _vm._e(),
            !_vm.is_null(_vm.content.orderUser)
              ? _c("p", [
                  _vm._v(
                    " 收货地址：" + _vm._s(_vm.content.orderUser.address) + " "
                  ),
                ])
              : _vm._e(),
          ]),
          _vm.content.orderUser
            ? _c("li", [
                !_vm.is_null(_vm.content.orderUser.comment)
                  ? _c("p", [
                      _vm._v(
                        " 备注：" + _vm._s(_vm.content.orderUser.comment) + " "
                      ),
                    ])
                  : _vm._e(),
                _vm.is_null(_vm.content.orderUser.comment)
                  ? _c("p", [_vm._v("备注：无")])
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "orderBox" },
        [
          _c("p", { staticClass: "header" }, [_vm._v("订单商品")]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.content.orderCommodityList },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "name", label: "商品名称" },
              }),
              _c("el-table-column", {
                attrs: { prop: "number", label: "商品数量", width: "180" },
              }),
              _c("el-table-column", {
                attrs: { prop: "price", label: "商品单价" },
              }),
              _c("el-table-column", {
                attrs: { prop: "brandName", label: "商品品牌" },
              }),
              _c("el-table-column", {
                attrs: { prop: "typeName", label: "商品分类" },
              }),
              _c("el-table-column", {
                attrs: { prop: "specificationName", label: "商品规格" },
              }),
              _c("el-table-column", {
                attrs: { prop: "total", label: "商品小计" },
              }),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.content.orderComplimentaryList },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "complimentaryName", label: "赠品名称" },
              }),
              _c("el-table-column", {
                attrs: { prop: "number", label: "赠品数量", width: "180" },
              }),
              _c("el-table-column", {
                attrs: { prop: "price", label: "赠品单价" },
              }),
              _c("el-table-column", {
                attrs: { prop: "brandName", label: "赠品品牌" },
              }),
              _c("el-table-column", {
                attrs: { prop: "typeName", label: "赠品分类" },
              }),
              _c("el-table-column", {
                attrs: { prop: "specificationName", label: "赠品规格" },
              }),
              _c("el-table-column", {
                attrs: { prop: "total", label: "赠品小计" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "total" }, [
        !_vm.is_null(_vm.content.orderUser)
          ? _c("p", [
              _vm._v(
                " 总计：共 " +
                  _vm._s(_vm.content.orderUser.pieceNumber) +
                  " 件 "
              ),
            ])
          : _vm._e(),
        !_vm.is_null(_vm.content.orderUser)
          ? _c("p", [
              _vm._v(" 运费：" + _vm._s(_vm.content.orderUser.charge) + " "),
            ])
          : _vm._e(),
        !_vm.is_null(_vm.content.orderUser)
          ? _c("p", [
              _vm._v(" 总价：" + _vm._s(_vm.content.orderUser.money) + " "),
            ])
          : _vm._e(),
      ]),
      _vm.gdJuage
        ? _c(
            "div",
            { staticClass: "fix" },
            [
              _c(
                "el-tabs",
                {
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.gdActive,
                    callback: function ($$v) {
                      _vm.gdActive = $$v
                    },
                    expression: "gdActive",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "改单前记录", name: "before" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "address",
                          staticStyle: { margin: "0", padding: "0" },
                        },
                        [
                          _c("p", { staticClass: "header" }, [
                            _vm._v("改单前收货地址"),
                          ]),
                          _c("ul", [
                            _c("li", [
                              !_vm.is_null(_vm.tableData.userChangeBefore)
                                ? _c("p", [
                                    _vm._v(
                                      " 收货人姓名：" +
                                        _vm._s(
                                          _vm.tableData.userChangeBefore
                                            .orderUserChange.addressName
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                              !_vm.is_null(_vm.tableData.userChangeBefore)
                                ? _c("p", [
                                    _vm._v(
                                      " 联系电话：" +
                                        _vm._s(
                                          _vm.tableData.userChangeBefore
                                            .orderUserChange.addressPhone
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                              !_vm.is_null(_vm.tableData.userChangeBefore)
                                ? _c("p", [
                                    _vm._v(
                                      " 收货地址：" +
                                        _vm._s(
                                          _vm.tableData.userChangeBefore
                                            .orderUserChange.address
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _c("li", [_c("p", [_vm._v("备注：无")])]),
                          ]),
                        ]
                      ),
                      !_vm.is_null(_vm.tableData.userChangeBefore)
                        ? _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.tableData.userChangeBefore
                                  .commodityChangeList,
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { prop: "name", label: "商品名称" },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "number", label: "商品数量" },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "price", label: "商品单价" },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "brandName", label: "商品品牌" },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "typeName", label: "商品分类" },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "specificationName",
                                  label: "商品规格",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "total", label: "商品小计" },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "updatedTime",
                                  label: "更新时间",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.is_null(_vm.tableData.userChangeBefore)
                        ? _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.tableData.userChangeBefore
                                  .complimentaryChangeList,
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "complimentaryName",
                                  label: "赠品名称",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "number", label: "赠品数量" },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "price", label: "赠品单价" },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "brandName", label: "赠品品牌" },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "typeName", label: "赠品分类" },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "specificationName",
                                  label: "赠品规格",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "total", label: "赠品小计" },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "updatedTime",
                                  label: "更新时间",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.qrtype == 1 ? "设置微信支付二维码" : "物流二维码",
            visible: _vm.dialogVisible,
            width: "50%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "qrcode" }, [
            _c(
              "div",
              { staticClass: "div" },
              [
                _c("span", [_vm._v("公众号：")]),
                _c(
                  "el-select",
                  {
                    attrs: {
                      filterable: "",
                      placeholder: "请选择公众号",
                      clearable: "",
                      "default-first-option": "",
                      size: "mini",
                    },
                    model: {
                      value: _vm.officialVal,
                      callback: function ($$v) {
                        _vm.officialVal = $$v
                      },
                      expression: "officialVal",
                    },
                  },
                  _vm._l(_vm.official, function (items) {
                    return _c("el-option", {
                      key: items.id,
                      attrs: { label: items.name, value: items.id },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _vm.qrtype == 1
              ? _c(
                  "div",
                  { staticClass: "div" },
                  [
                    _c("span", [_vm._v("订单金额：")]),
                    _c("el-input-number", {
                      attrs: {
                        mix: 0,
                        precision: 2,
                        max: _vm.content.orderUser.awaitIncomeMoney,
                        size: "mini",
                      },
                      model: {
                        value: _vm.orderMoney,
                        callback: function ($$v) {
                          _vm.orderMoney = $$v
                        },
                        expression: "orderMoney",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.qrtype == 1
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function ($event) {
                          return _vm.generate()
                        },
                      },
                    },
                    [_vm._v("生成二维码")]
                  )
                : _vm._e(),
              _vm.qrtype == 1
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function ($event) {
                          return _vm.pushOrderInfo()
                        },
                      },
                    },
                    [_vm._v("微信推送")]
                  )
                : _vm._e(),
              _vm.qrtype == 2
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function ($event) {
                          return _vm.generate()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.qrtype == 1 ? "微信支付二维码" : "物流二维码",
            visible: _vm.qrHidden,
            width: "50%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.qrHidden = $event
            },
          },
        },
        [
          _c("div", { attrs: { id: "contentQr" } }),
          _vm.qrtype == 1 && _vm.orderMoney == 0
            ? _c(
                "div",
                {
                  staticStyle: { "text-align": "center", "margin-top": "40px" },
                },
                [_vm._v(" 注：此二维码只供查看订单使用 ")]
              )
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.qrHidden = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "物流信息",
            visible: _vm.distributionDialogVisible,
            width: "30%",
            "before-close": _vm.handleCloseDistribution,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.distributionDialogVisible = $event
            },
          },
        },
        [
          _vm.logistlist.length != 0
            ? _c(
                "div",
                { staticStyle: { "max-height": "300px", overflow: "scroll" } },
                [
                  _c("div", [
                    _c("span", { staticStyle: { "margin-left": "20px" } }, [
                      _vm._v(_vm._s(_vm.logistlist.expTextName)),
                    ]),
                    _c("span", { staticStyle: { "margin-left": "15px" } }, [
                      _vm._v(_vm._s(_vm.logistlist.mailNo)),
                    ]),
                  ]),
                  _c(
                    "el-steps",
                    { attrs: { direction: "vertical", active: 0, space: 100 } },
                    _vm._l(_vm.logistlist.data, function (item, index) {
                      return _c("el-step", {
                        key: index,
                        attrs: { title: item.context, description: item.time },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _c("div", [
                _c(
                  "span",
                  {
                    staticStyle: {
                      color: "#909399",
                      display: "flex",
                      "justify-content": "center",
                    },
                  },
                  [_vm._v(" 暂无物流信息~")]
                ),
              ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.distributionDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.distributionDialogVisible = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }